import { render, staticRenderFns } from "./getMemberLabelList.vue?vue&type=template&id=a66c520c&lang=pug"
import script from "./getMemberLabelList.vue?vue&type=script&lang=js"
export * from "./getMemberLabelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports